import { createContext, useState } from "react";
import { upcomingData , pastData } from "../mock/trips";

export const ManageBookingContext = createContext();

function ManageBookingContextProvider({ children }) {
  const [upcomingTrips, setUpcomingTrips] = useState(upcomingData);
  const [pastTrips, setPastTrips] = useState(pastData);
  const [currentTrip, setCurrentTrip] = useState({});
  const [cancelFinalBooking, setCancelFinalBooking] = useState({});
  const [razorpayResponseData, setRazorpayResponseData] = useState({});

  const values = {
    upcomingTrips,
    pastTrips,
    currentTrip,
    cancelFinalBooking,
    razorpayResponseData,
    setUpcomingTrips,
    setPastTrips,
    setCurrentTrip,
    setCancelFinalBooking,
    setRazorpayResponseData
  };

  return <ManageBookingContext.Provider value={values}>{children}</ManageBookingContext.Provider>;
}

export default ManageBookingContextProvider;
